import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ArticleView from "./components/ArticleView";

export default function ArticlePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <ArticleView />
      <Footer />
    </div>
  );
}
